exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".version-insert {\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n  background: #ffffff;\n  border: 1px solid #e5e5e5;\n  padding: 30px;\n}\n.version-insert .add-complete {\n  width: 100%;\n  min-height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.version-insert .insert-top {\n  margin-bottom: 20px;\n  width: 60%;\n  margin-left: 20%;\n}\n.version-insert .ant-upload-drag {\n  border: 0;\n}\n.version-insert .ant-upload-drag .ant-upload-drag-warp {\n  width: 420px;\n  height: 128px;\n  border: 1px #ccc dashed;\n  border-radius: 5px;\n}\n.version-insert .ant-form {\n  width: 720px;\n  margin: 0 auto;\n}\n.version-insert .ant-btn {\n  margin-right: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/version/insert/index.less
// module id = 1540
// module chunks = 0